<template>
  <v-card
    height="100%"
    dark
    class="d-flex justify-center align-center transparent py-10"
  >
    <v-card width="900px" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row align="center" no-gutters>
        <v-col cols="4">
          <v-card height="100%" width="100%">
            <v-img
              height="400px"
              width="100%"
              src="https://lh3.googleusercontent.com/UdVgHEOVZm30cUPw5wANFMkBz7fyUJnTuIjWtNJ2SdEQTOBT_MhtZlrbevia7FvY3MwncmfnP0zD5O2XjUeeYRzjBDEDr6xKYPV6R_cGD2Qih6ps_mlkHFhXms1m1Ee7LugUYmlzdANqmLBpZCJ-vOSa9WIGo9yLwp6Q8mpcqx_D_dC1sz9mITBTkGgJpbOKHDQVD3kTyFGMz9WiVUnjm4QucABTYBrGlJfjYW3IA8q6ZocdbvmNwLVYNQkogzBnmSzfR3enCQvf3lAksyK4-SCp_YcCDqnHtGxNgiobW7d61jBERwaaKwzob8da_gFy93FqmMh9zvWbuDRcG8KlLXY57iBdXe8moZFfdKhlG1Gn31vMf0-q1X3EdWwykwnGk2kDifSphnKOuj9sUwWS5G-8h13EZxFged4WoNVJZQMiPewWo9izHu93ApiAAxRuL8ZF0dWViEip-7Pm8it3hPT6ZtTKCQwv99QEw85vVjDBhUnSKdsB-Syzg0I0H9l4OOC8aXqQUnuTrL-mXeSJdIKEXkupyBZsCrKOpupZJVzGJhIgqdPmquM6vurTTUg42UgPQ3rNPUH0w8BdbzDJGX1vIjNzXWeNTX9rEA81032nubDY-uxp13Z_qjSot3EGmDTDfajau-aXPw-bbK_WNCJSiMfbQ8qdG80g1TM2g0kNfJUjGloHodg=w753-h1003-no"
            ></v-img>
          </v-card>
        </v-col>
        <v-col cols="8" class="d-flex align-center">
          <v-card flat>
            <v-container class="pa-12">
              <v-card-title>
                <vue-typed-js :strings="['Contact me.']" :typeSpeed="80">
                  <span class="typing"></span>
                </vue-typed-js>
              </v-card-title>
              <v-card-text>
                <v-icon left>mdi-account</v-icon> Ly Chunvira <br />
                <v-icon left>mdi-map</v-icon> #11D, St. 230, Toul Kork, Phnom
                Penh, Cambodia <br />
                <v-icon left>mdi-phone</v-icon> +855 99 758 566 <br />
                <v-icon left>mdi-email</v-icon> lychunvira@gmail.com <br />
                <v-icon left>fab fa-linkedin</v-icon> Ly Chunvira <br />
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      v-else
      class="mx-auto"
      :max-width="$vuetify.breakpoint.sm ? '544' : '344'"
    >
      <v-img
        class="white--text align-end"
        height="200px"
        src="https://lh3.googleusercontent.com/UdVgHEOVZm30cUPw5wANFMkBz7fyUJnTuIjWtNJ2SdEQTOBT_MhtZlrbevia7FvY3MwncmfnP0zD5O2XjUeeYRzjBDEDr6xKYPV6R_cGD2Qih6ps_mlkHFhXms1m1Ee7LugUYmlzdANqmLBpZCJ-vOSa9WIGo9yLwp6Q8mpcqx_D_dC1sz9mITBTkGgJpbOKHDQVD3kTyFGMz9WiVUnjm4QucABTYBrGlJfjYW3IA8q6ZocdbvmNwLVYNQkogzBnmSzfR3enCQvf3lAksyK4-SCp_YcCDqnHtGxNgiobW7d61jBERwaaKwzob8da_gFy93FqmMh9zvWbuDRcG8KlLXY57iBdXe8moZFfdKhlG1Gn31vMf0-q1X3EdWwykwnGk2kDifSphnKOuj9sUwWS5G-8h13EZxFged4WoNVJZQMiPewWo9izHu93ApiAAxRuL8ZF0dWViEip-7Pm8it3hPT6ZtTKCQwv99QEw85vVjDBhUnSKdsB-Syzg0I0H9l4OOC8aXqQUnuTrL-mXeSJdIKEXkupyBZsCrKOpupZJVzGJhIgqdPmquM6vurTTUg42UgPQ3rNPUH0w8BdbzDJGX1vIjNzXWeNTX9rEA81032nubDY-uxp13Z_qjSot3EGmDTDfajau-aXPw-bbK_WNCJSiMfbQ8qdG80g1TM2g0kNfJUjGloHodg=w753-h1003-no"
      >
      </v-img>
      <v-card-title>Contact me</v-card-title>
      <v-card-text class="">
        <v-icon left>mdi-account</v-icon> Ly Chunvira <br />
        <v-icon left>mdi-map</v-icon> #11D, St. 230, Toul Kork, Phnom Penh,
        Cambodia <br />
        <v-icon left>mdi-phone</v-icon> +855 99 758 566 <br />
        <v-icon left>mdi-email</v-icon> lychunvira@gmail.com <br />
        <v-icon left>fab fa-linkedin</v-icon> Ly Chunvira <br />
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
